module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.a35720c2.woff";